
import MainSettingContext from './MainSettingContext';
import React, { Component } from 'react'; //different
//import './style.css';
import Login from './login';
import instance from "./axios-instance";
import { getMainSettingCached } from "./sharedApi";
import Systems from "./SystemFunction";
class App extends Component {
    static contextType = MainSettingContext;

    constructor(props) {
        super(props)
        this.state = {
            linelink: "",
            imglogo: "",
        }
    }
    async componentDidMount() {
        await getMainSettingCached() /* [2026-10-25] ร่วม request/cache กับ main.js (sharedApi) */.then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                this.setState({
                    linelink: datas[1].value,
                    logoimg: res.data.tblsetting[0].imglogo,
                });
            }
            else {
                // this.CheckThisGoalError();
            }
        });

    }
    render() {
        return (
            <div className="sol-auth-card">
                <div className="sol-logo">
                    <img src={this.state.logoimg} alt="" />
                </div>
                <h2 className="sol-title">เข้าสู่ระบบ</h2>

                <Login />

                <button
                    className="sol-btn sol-btn-outline"
                    onClick={(e) => { e.preventDefault(); window.location.href = '/register'; }}
                >
                    สมัครสมาชิก
                </button>

                <a href={this.state.linelink} className="sol-contact">
                    พบปัญหา <span>ติดต่อฝ่ายบริการลูกค้า</span>
                </a>
            </div>
        );
    }
}
export default App;
